//
// Module for the MemberDirect FAQ edit view
//
rs.module("content/system/configuration/faqs/order",

    [
        "controls/data/grid",
        "controls/components/event-banner",
    ],

    function (gridModule, eventBanner) {
        //
        // Initialize the module
        //
        function initialize(jsSelectors, lrsGridApi, backendUrl, columnIds) {
            var filter = $.js(jsSelectors.filter);
            var displayFlagRadioButtons = filter.js(jsSelectors.displayFlagRadioButtons);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            var agGridApi = lrsGridApi.agGridApi;

            sortRows();

            //update the grid
            displayFlagRadioButtons.find('input').click(function () {
                loadingSpinner.show();

                gridModule.update(
                    backendUrl,
                    { preLoginFlag: isPreLoginSelected() },
                    agGridApi,
                    function done() {
                        // Update the sorting to the new column
                        sortRows();

                        loadingSpinner.hide();
                        eventBanner.removeAllMessages();
                    }
                );
            });

            //swap clicked row with the one above it
            $(document).onjs("click", jsSelectors.gridUpArrow, function () {
                var clickedRowIndex = getClickedRowIndex(this);
                swapGridRows(clickedRowIndex, clickedRowIndex - 1);
            });

            //swap clicked row with the one below it
            $(document).onjs("click", jsSelectors.gridDownArrow, function () {
                var clickedRowIndex = getClickedRowIndex(this);
                swapGridRows(clickedRowIndex, clickedRowIndex + 1);
            });

            //sort the rows by the selected index and remove the sort for the other index
            function sortRows() {

                var sort = [ columnIds.PreLoginIndex, columnIds.PostLoginIndex ];
                if (!isPreLoginSelected()) {
                    sort = sort.reverse();
                }

                agGridApi.applyColumnState({
                    state: [
                        {
                            colId: sort[0],
                            sort: 'asc'
                        },
                        {
                            colId: sort[1],
                            sort: null
                        }
                    ]
                });
            }

            // Determine if pre-login is selected
            function isPreLoginSelected() {
                return displayFlagRadioButtons.find('input:checked').val() === "true";
            }

            // get the clicked row's index
            function getClickedRowIndex(clickedArrow) {
                var faqKey = clickedArrow.dataset.faqkey;

                var clickedRowIndex;
                agGridApi.forEachNode((row) => {
                    if (row.data.FaqKey == faqKey) {
                        clickedRowIndex = row.rowIndex;
                    }
                });

                return clickedRowIndex;
            }

            // Swap the index values of two rows
            function swapGridRows(row1Index, row2Index) {
                var row1 = agGridApi.getDisplayedRowAtIndex(row1Index);
                var row2 = agGridApi.getDisplayedRowAtIndex(row2Index);

                var fieldName = isPreLoginSelected() ? columnIds.PreLoginIndex : columnIds.PostLoginIndex;
                var row1Rank = row1.data[fieldName];
                var row2Rank = row2.data[fieldName];

                // Update the grid data, swapping Rank
                lrsGridApi.updateRow(row1, { [fieldName] : row2Rank });
                lrsGridApi.updateRow(row2, { [fieldName] : row1Rank });
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);